import { Map } from 'immutable';

import { createController } from '../utils/controller';
import api from '../utils/api';

import { SCHEDULE_TYPE_API_KEY, SCHEDULE_TYPES } from '../constants/schedule';
import { EMPTY } from '../constants';

import scheduleListings from './schedule.listings';
import scheduleUpdates from './schedule.updates';
import actions from '../actions';

const controller = createController();

function* bootstrap(state, { shopId }) {
  const shop = state.getIn(['shops', 'byId', shopId]);
  const channel = shop.get('channel');
  const db = shop.get('db');

  yield function effect(dispatch) {
    dispatch(actions.schedule.getCounts());
  };

  return state.set('schedule', Map({ channel, db, shopId }));
}

function* cleanUp(state) {
  controller.stop();
  return state.set('schedule', EMPTY.MAP);
}

function* getCounts(state) {
  const shopId = state.getIn(['schedule', 'shopId']);
  const db = state.getIn(['schedule', 'db']);

  if (shopId && db) {
    yield function effect(dispatch) {
      const { signal } = controller.start();

      api.schedule.counts
        .get({ db, shopId, signal })
        .then(
          (response) => dispatch(actions.schedule.getCounts.fulfilled({ response, shopId })),
          (error) => dispatch(dispatch(actions.schedule.getCounts.rejected({ error, shopId, signal })))
        );
    };
  }

  return state;
}

function* getCountsFulfilled(state, { response, shopId }) {
  if (shopId !== state.getIn(['schedule', 'shopId'])) return state;

  controller.stop();

  function reduceTypes(result, type) {
    return result.set(type, parseInt(response[SCHEDULE_TYPE_API_KEY[type]], 10) || 0);
  }

  return state
    .setIn(['schedule', 'loaded'], true)
    .setIn(['schedule', 'counts'], SCHEDULE_TYPES.reduce(reduceTypes, EMPTY.MAP));
}

function* getCountsRejected(state, { error, shopId, signal }) {
  if (signal.aborded || shopId !== state.getIn(['schedule', 'shopId'])) return state;

  controller.stop();
  console.error(error);

  return state;
}

const schedule = {
  [actions.schedule.bootstrap]: bootstrap,
  [actions.schedule.cleanUp]: cleanUp,
  [actions.schedule.getCounts]: getCounts,
  [actions.schedule.getCounts.fulfilled]: getCountsFulfilled,
  [actions.schedule.getCounts.rejected]: getCountsRejected,
  ...scheduleListings,
  ...scheduleUpdates,
};

export default schedule;
